import * as React from "react"
import { Typography } from '@mui/material'


export default function sectionColumn() {
    return {
		name: 'section',
		label: 'Section',
		options: {
			setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRenderLite: value => <Typography sx={{ fontSize: '0.875rem' }}>
                {value || '-'}
            </Typography>
		}
	}
}